import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class ObserveSearchService extends BaseService {
  constructor() {
    super(constants.GET_OBSERVE_SEARCH_DATA, constants.OBSERVE_SEARCH_STATUS);
  }

  /**
   * Posts the Observe search; cursor-paged (Observe + OTEL) searches go to the v3 endpoint.
   */
  async handleEvent(eventName, event) {
    const { payload, headers } = utils.buildRequestPartsFromPayload(event);
    const { isStackB } = utils.getStackBParams();
    const endpoint = constants.OBSERVE_SEARCH_ENDPOINT;
    const version = event.cursorPaging ? 'v3' : 'v2';

    if (isStackB) {
      const enhancedHeaders = await utils.resolveStackBHeaders(headers);
      return this.getClient(`aiadminstackb${version}`).post(endpoint, payload, { headers: enhancedHeaders });
    }
    return this.getClient(`aiadmin${version}`).post(endpoint, payload, { headers });
  }

  handleResponse(response) {
    const { data } = response;
    if (data.status === 'success') {
      Framework.getStoreRegistry().getStore('observeSearch').setResponse(response.data);
    }
  }

  handleError(error) {
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
      if (status === 400 && data && data.message) {
        const notification = {
          open: true,
          message: data.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
    Framework.getStoreRegistry().getStore('observeSearch').resetStoreValues();
  }
}
